import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { captureForceAgenticFlag } from '@views/Stream/agentic';

// Before the sign-in redirect drops the query string.
captureForceAgenticFlag();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// Register service worker for PWA support. https://cra.link/PWA
serviceWorkerRegistration.register();

// Core Web Vitals are published from the Login view (see reportWebVitals.ts):
// registration must be complete so metrics carry the correct region.
